import React from "react";
import { IPageSectionResponse, SectionType } from "models/response/page-section-response";
import { FreeTextSection } from "./sections/FreeTextSection";
import { ItemListSection } from "./sections/ItemListSection";
import { ImageGallerySection } from "./sections/ImageGallerySection";
import { AccordionFaqSection } from "./sections/AccordionFaqSection";
import { MixedContentSection } from "./sections/MixedContentSection";
import { VideoEmbedSection } from "./sections/VideoEmbedSection";
import { SectionWrapper } from "./custom-page.styles";

interface SectionFactoryProps {
    section: IPageSectionResponse;
}

export const SectionFactory: React.FC<SectionFactoryProps> = ({ section }) => {
    return (
        <SectionWrapper>
            {(() => {
                switch (section.type) {
                    case SectionType.FreeText:
                        return <FreeTextSection section={section} />;
                    case SectionType.ItemList:
                        return <ItemListSection section={section} />;
                    case SectionType.ImageGallery:
                        return <ImageGallerySection section={section} />;
                    case SectionType.AccordionFaq:
                        return <AccordionFaqSection section={section} />;
                    case SectionType.MixedContent:
                        return <MixedContentSection section={section} />;
                    case SectionType.VideoEmbed:
                        return <VideoEmbedSection section={section} />;
                    default:
                        return null;
                }
            })()}
        </SectionWrapper>
    );
};
